export default __webpack_public_path__ + "static/media/stocks.edebaea8.svg";